/**
 * Геометрия и типографика `UDButton`, общие для кнопки и её плашки в скелетоне
 * (`ud-ui/components/skeleton`). Ширину плашки задаёт подпись кнопки, поэтому шрифт обязан
 * совпадать: без `typo body-2` подпись наследовала шрифт страницы и плашка выходила на 4px
 * шире кнопки (IMGM-1491).
 */
export const BUTTON_TYPOGRAPHY_CLASS = 'typo body-2';

/** Высота 36px, поля 8px × 16px и рамка 1px — те же, что у `Button` в `./styles.ts`. */
export const BUTTON_BOX_CLASS = 'h-9 px-4 border';
